import React, { useState } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { NavLink } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import moment from "moment";
import FeeSystemMenu from "./FeeSystemMenu";

function DateWiseCollectionReport() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));

  const [loading, setLoading] = useState(false);
  const [StartDate, setStartDate] = useState(moment().startOf("month").format("YYYY-MM-DD"));
  const [EndDate, setEndDate] = useState(moment().endOf("month").format("YYYY-MM-DD"));
  const [IncludeUnposted, setIncludeUnposted] = useState(false);
  const [rows, setRows] = useState([]);
  const [totals, setTotals] = useState({
    TotalReceiptCount: 0,
    TotalKuickPay: 0,
    TotalBankOfPunjab: 0,
    TotalGrand: 0,
  });

  const getReport = async () => {
    if (!StartDate || !EndDate) return;
    setLoading(true);
    try {
      const response = await axios({
        method: "post",
        url: config.base_url + "FeeSystem/GetDateWiseCollectionReport",
        headers: { "Content-Type": "application/json" },
        data: {
          AccessKey,
          UserID,
          MemberType,
          StartDate,
          EndDate,
          IncludeUnpostedEntries: IncludeUnposted,
        },
      });

      if (response.data?.status_code === 1) {
        setRows(response.data.ListofRecords || []);
        setTotals({
          TotalReceiptCount: response.data.TotalReceiptCount || 0,
          TotalKuickPay: response.data.TotalKuickPay || 0,
          TotalBankOfPunjab: response.data.TotalBankOfPunjab || 0,
          TotalGrand: response.data.TotalGrand || 0,
        });
      } else {
        setRows([]);
        setTotals({
          TotalReceiptCount: 0,
          TotalKuickPay: 0,
          TotalBankOfPunjab: 0,
          TotalGrand: 0,
        });
        toast.error(response.data?.status_message || "No Data Found", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (error) {
      toast.error("Network Error..", { position: toast.POSITION.TOP_RIGHT });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ToastContainer />
      <FeeSystemMenu />
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <NavLink to="/Dashboard">Dashboard</NavLink>
                    </li>
                    <li className="breadcrumb-item">
                      <NavLink to="/FeeSystem/FeeSystemDashboard">Fee System</NavLink>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      DateWise Collection
                    </li>
                  </ol>
                </nav>
                <div className="page-title">DateWise Collection</div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-content">
          <div className="container">
            <div className="card mb-2">
              <div className="card-body">
                <div className="row align-items-end">
                  <div className="col-md-3">
                    <label>Start Date :</label>
                    <input
                      type="date"
                      className="form-control"
                      value={StartDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      max={moment().format(config.date_format_input)}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>End Date :</label>
                    <input
                      type="date"
                      className="form-control"
                      value={EndDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      max={moment().format(config.date_format_input)}
                    />
                  </div>
                  <div className="col-md-3">
                    <div className="form-check mt-4">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={IncludeUnposted}
                        onChange={() => setIncludeUnposted(!IncludeUnposted)}
                        id="includeUnpostedEntries"
                      />
                      <label className="form-check-label" htmlFor="includeUnpostedEntries">
                        Include Unposted Entries
                      </label>
                    </div>
                  </div>
                  <div className="col-md-3 text-end">
                    <button type="button" onClick={getReport} className="button button-primary w-100">
                      View Report
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="card">
              <div className="card-body">
                <table className="table table-theme">
                  <thead>
                    <tr>
                      <th>Sr. No</th>
                      <th>Dated</th>
                      <th>Receipt Count</th>
                      <th>KuickPay Total</th>
                      <th>Bank of Punjab Total</th>
                      <th>Grand Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td className="text-center" colSpan="6">
                          <Spinner animation="border" role="status"></Spinner>
                        </td>
                      </tr>
                    ) : rows.length > 0 ? (
                      <>
                        {rows.map((item, index) => (
                          <tr key={index}>
                            <td>{item.Serial_No || index + 1}</td>
                            <td>{moment(item.Dated).format(config.date_format)}</td>
                            <td>{item.ReceiptCount}</td>
                            <td>{item.KuickPayTotal}</td>
                            <td>{item.BankOfPunjabTotal}</td>
                            <td>{item.GrandTotal}</td>
                          </tr>
                        ))}
                        <tr>
                          <td colSpan={2}><b>Total</b></td>
                          <td><b>{totals.TotalReceiptCount}</b></td>
                          <td><b>{totals.TotalKuickPay}</b></td>
                          <td><b>{totals.TotalBankOfPunjab}</b></td>
                          <td><b>{totals.TotalGrand}</b></td>
                        </tr>
                      </>
                    ) : (
                      <tr>
                        <td colSpan="6">
                          <h4 className="mt-3" style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}>
                            No Data Found
                          </h4>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DateWiseCollectionReport;
